<template>
  <v-flex :md4="md==4">
    <b><fs1-span>{{label||'Clase de Asset'}}</fs1-span></b>
    <v-select
      :placeholder="model ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      item-text="name"
      item-value="id"
      :disabled="disabled"
      :class="!model && 'textEmpty'"/>
      <value-container v-if="old_value !== undefined" :value="(items.find(f=>f.id==old_value)||{}).name||''" class_name="output_old_value_edit"/>
  </v-flex>
</template>
<script>
import in_select from '../mixins/inputs/select.js';
export default {
  mixins:[in_select],
  computed: {
    items(){ return this.$store.getters.asset_class },
  },
};
</script>
